import { generatedAPI } from '@grafana/api-clients/rtkq/dashboard/v0alpha1';

export const dashboardAPIv0alpha1 = generatedAPI.enhanceEndpoints({});

export const { useSearchDashboardsAndFoldersQuery } = dashboardAPIv0alpha1;
